class DynamicLinkService {

  constructor(ApiService, $q, DynamicLinkSchema, Upload) {
    this.$q = $q;
    this.ApiService = ApiService;
    this.Upload = Upload;
    this.DynamicLinkSchema = DynamicLinkSchema;

    this.dynamicLinkEndpoint = '/api/dynamiclinks';
    this.imageEndpoint = "/api/upload";
    this.deleteImageEndpoint = this.dynamicLinkEndpoint + "/deleteimage";
  }

  /**
   * Get new empty dynamicLink schema
   * @returns {*}
     */
  getNew() {
    return this.DynamicLinkSchema;
  }

  /**
   * Get all dynamicLinks
   * @returns {*}
     */
  get() {
    var self = this;
    return self.ApiService.get(self.dynamicLinkEndpoint + '/more_items')
      .then((response) => { return response.data; });
  }

  /**
   * Get dynamicLink by ID
   * @param id
   * @returns {*}
     */
  getById(id) {
    var self = this;
    return self.ApiService.get(self.dynamicLinkEndpoint + '/' + id)
      .then((response) => { return response.data; });
  }

  /**
   * Send new dynamicLink to server
   * @param dynamicLink
   * @param file
   * @returns {*}
     */
  addNew(dynamicLink, file) {
    var self = this;

    // save the image
    return self.saveImage(dynamicLink, file)
      .then(function (response) {

        if (response) {
          // add image details to dynamicLink object
          dynamicLink.imageUrl = response.data.image.url;
        } else {
          return self.$q.reject({ type: "image", message: "The image has incorrect dimensions" });
        }

        dynamicLink.type = "more_items";

        // get object ready
        var readyData = angular.copy(dynamicLink);

        // save the dynamicLink
        return self.ApiService.post(self.dynamicLinkEndpoint, readyData);
      });

  }

  /**
   * Send updated dynamicLink data to server
   * @param dynamicLink
   * @returns {*}
     */
  updateDynamicLink(dynamicLink, file) {
    var self = this;
    return self.saveImage(dynamicLink, file)
      .then((response) => {

        // add icon details to filter object
        if (response) {

          if (response.data.image) {
            // add image details to object
            dynamicLink.imageUrl = response.data.image.url;
          }
          else {
            return self.$q.reject({ type: "image", message: "The image has incorrect dimensions" });
          }
        }

        dynamicLink.type = "more_items";
        var dynamicLinkFormatted = self.stripUnnecessaryFields(dynamicLink);

        // save the dynamicLink
        return self.ApiService.put(self.dynamicLinkEndpoint + '/' + dynamicLinkFormatted.id, dynamicLinkFormatted);
      });

  }


  saveImage(dynamicLink, file) {
    var self = this;

    if (file) {
      return self.Upload.upload({
        url: self.imageEndpoint + '/dynamic_link',
        data: { file: file }
      }).catch((response) => {

        var error = { type: 'image', message: "Unknown error saving the dynamic link" };
        if (response.data.error) {
          error.message = response.data.message;
        }
        return self.$q.reject(error);
      });
    }
    else if (dynamicLink.imageUrl !== null) {
      return self.ApiService.post(self.deleteImageEndpoint + "/" + dynamicLink.id)
        .then(() => {
          return { data: { image: { url: null } } };
        });
    }
    else {
      return self.$q.when(null);
    }
  }


  /**
   * Delete dynamicLink from server
   * @param dynamicLinkId
   * @returns {*}
     */
  deleteDynamicLink(dynamicLinkId) {
    var self = this;
    return self.ApiService._delete(self.dynamicLinkEndpoint + '/' + dynamicLinkId);
  }

  stripUnnecessaryFields(dynamicLink) {
    var formattedDynamicLink = {
      "id": dynamicLink.id,
      "name": dynamicLink.name,
      "url": dynamicLink.url,
      "imageUrl": dynamicLink.imageUrl,
      "type": dynamicLink.type
    };
    return formattedDynamicLink;
  }

}
DynamicLinkService.$inject = ['ApiService', '$q', 'DynamicLinkSchema', 'Upload'];
export default DynamicLinkService;
